import { render, staticRenderFns } from "./PayrollTopBar.vue?vue&type=template&id=431652e1&scoped=true"
import script from "./PayrollTopBar.vue?vue&type=script&lang=js"
export * from "./PayrollTopBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431652e1",
  null
  
)

export default component.exports